import { VueController } from 'util/vue_controller'

// Connects to data-controller="distributor-credit-submissions"
export default class extends VueController {
  static vueComponent = 'distributor-credit-submissions'

  static targets = ['tableBody', 'confirmation']

  static values = {
    chains: Array,
    submissions: Array,
    pricingPrograms: Array,
    team: String
  }

  get props () {
    return {
      chains: this.chainsValue,
      submissions: this.submissionsValue,
      pricingPrograms: this.pricingProgramsValue,
      team: this.teamValue
    }
  }

  get vueTarget () {
    return this.tableBodyTarget
  }

  handleEvent (eventName, _data) {
    switch (eventName) {
      case 'confirmation':
        this.#showConfirmation()
        break
    }
  }

  #showConfirmation () {
    const template = this.confirmationTarget.content.cloneNode(true)
    this.element.insertBefore(template, this.element.firstChild)
  }
}
